import { Button, Card, Header } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import UserLanguagesTable from "../../../../users/components/UserLanguagesTable/UserLanguagesTable";

import AddUserLanguageModal from "./AddUserLanguageModal";

export default function AccountLanguages({ user }) {
	const { t } = useTranslation();

	const [openModal, setOpenModal] = useState(false);

	return (
		<>
			<Header as="h3">{t("languageSkills", "Language skills")}</Header>

			<Card fluid>
				<Card.Content>
					<UserLanguagesTable user={user} />

					{openModal && <AddUserLanguageModal user={user} onClose={() => setOpenModal(false)} />}
				</Card.Content>

				<Card.Content>
					<Button primary onClick={() => setOpenModal(true)}>
						{t("add", "Add")}
					</Button>
				</Card.Content>
			</Card>
		</>
	);
}
